module.exports = ".version-text {\r\n    text-align: right; \r\n    padding-top: 10px; \r\n    padding-right: 10px; \r\n    font-size: 12px\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 655
// module chunks = 1